export default "__VITE_ASSET__DBYutpDk__"